// This is the central place for all Feature toggles for BP Admin
import dayjs from 'dayjs'
import flagOz from './australia.png' //
import flagUk from './uk.png' //

// These are hard-coded for convenience ToDo: Save elsewhere
const UKURL = 'https://api.wonde.com/v1.0/schools'
const UKTOKEN = 'Bearer a3f049794493180ed83fb310da37715f856c3670' // new as of 9/2/2022
const AUSURL = 'https://api-ap-southeast-2.wonde.com/v1.0/schools'
const AUSTOKEN = 'Bearer 4ef8fc0053696f4202062ac598943fc1de66c606' // new as of 9/2/2022

// used by AU rollover to get the table where teh list of manual schools are kept
export function getSchoolListTable() {
  switch (process.env.REACT_APP_REGION) {
    case 'ap-southeast-2':
      return 'au_rollover_schools' // same name in both accounts
    case 'eu-west-2':
      return 'uk_rollover_schools'
    default:
      return ''
  }
}
// used by AU rollover to get the S3 directory where classlists are kept
export function getBaseS3Directory() {
  switch (process.env.REACT_APP_REGION) {
    case 'ap-southeast-2':
      return 'AURollover'
    case 'eu-west-2':
      return 'UKRollover'
    default:
      return ''
  }
}

// FEATURE-TOGGLE
// The school year corresponds to the calendar year in Australia - if teh 2022 theh school year is 2022
// In UK if its 2022, then teh school year is 2022 up to Aug 31. After that it is 2023
export function getSchoolYear() {
  let thisMonth = dayjs().month() // months have index 0-11 so 8 is sept
  let thisYear = dayjs().year() // like 2022
  switch (process.env.REACT_APP_REGION) {
    case 'ap-southeast-2':
      return thisYear // return the calendar year
    case 'eu-west-2':
      if (thisMonth >= 7) {
        return thisYear + 1 // after Sept or later so add 1
      } else {
        return thisYear
      }
    default:
      return thisYear
  }
}

// If the school name in Elastik does not match the Wonde schoolname
// then BPAdmin will report that the school is not uploaded
// To solve this, we keep a list of where this occurs
export function getCorrectedSchoolName(wondeSchoolName) {
  let nameMap = new Map()
  switch (process.env.REACT_APP_REGION) {
    case 'ap-southeast-2': {
      nameMap.set('Resurrection School - Keysborough', 'Resurrection Primary School Keysborough')
      let elastikName = nameMap.get(wondeSchoolName)
      if (elastikName) return elastikName
      return wondeSchoolName
    }
    case 'eu-west-2':
      // Map of known spelling mistakes in Elastik
      // search by WondeSchoolName to get the ElastikSchoolName
      nameMap.set(
        'St Andrew and St Francis CofE Primary School', // Wonde Name
        'St Andrew and St Francis Church Of England Primary School', // Elastik version
      )
      nameMap.set('Claires Court Schools', 'Claires Court School')
      nameMap.set('York House School', 'York House')
      let elastikName = nameMap.get(wondeSchoolName)
      if (elastikName) return elastikName
      return wondeSchoolName
    default:
      return wondeSchoolName
  }
}

// FEATURE-TOGGLE
export function getURL() {
  //return AUSURL
  //return UKURL
  switch (process.env.REACT_APP_REGION) {
    case 'ap-southeast-2':
      return AUSURL
    case 'eu-west-2':
      return UKURL
    default:
      return AUSURL
  }
}
// FEATURE-TOGGLE
export function getToken() {
  //return AUSTOKEN
  //return UKTOKEN
  switch (process.env.REACT_APP_REGION) {
    case 'ap-southeast-2':
      return AUSTOKEN
    case 'eu-west-2':
      return UKTOKEN
    default:
      return AUSTOKEN
  }
}

// Helpers
export function getAUS_URL() {
  return AUSURL
}
export function getUK_URL() {
  return UKURL
}
export function getAUS_Token() {
  return AUSTOKEN
}
export function getUK_Token() {
  return AUSTOKEN
}

export function getYearCodeForYear0() {
  switch (process.env.REACT_APP_REGION) {
    case 'ap-southeast-2':
      return 'FY' // Foundation Year in Australia
    case 'eu-west-2':
      return 'R' // Reception in UK
    default:
      return 'FY'
  }
}

export function isAUSRegion() {
  if (process.env.REACT_APP_REGION === 'ap-southeast-2') return true
  return false
}

export function isUKRegion() {
  if (process.env.REACT_APP_REGION === 'eu-west-2') return true
  return false
}

// This returns the region code
export function getRegion() {
  return process.env.REACT_APP_REGION
}

// get the region name for display purposes FEATURE-TOGGLE
export function getRegionName() {
  switch (process.env.REACT_APP_REGION) {
    case 'ap-southeast-2':
      return `Sydney, Australia (${process.env.REACT_APP_REGION})`

    case 'eu-west-2':
      return `London, England ${process.env.REACT_APP_REGION}`

    default:
      return `Sydney, Australia (${process.env.REACT_APP_REGION})`
  }
}

// get the region name for display purposes FEATURE-TOGGLE
export function getRegionCountryCode() {
  switch (process.env.REACT_APP_REGION) {
    case 'ap-southeast-2':
      return `AU`

    case 'eu-west-2':
      return `UK`

    default:
      return `AU`
  }
}

// display a flag to represent the region of deployment FEATURE-TOGGLE
export function getRegionFlag() {
  switch (process.env.REACT_APP_REGION) {
    case 'ap-southeast-2':
      return flagOz

    case 'eu-west-2':
      return flagUk

    default:
      return flagOz
  }
}
